import en from ".././lang/en.json"; // Import the English translations
import es from ".././lang/es.json"; // Import the Spanish translations
import pt from ".././lang/pt.json"; // Import the Portuguese translations
import fr from ".././lang/fr.json"; // Import the French translations
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import PropTypes from 'prop-types';

const messages = {
    en,
    es,
    pt,
    fr,
};

const Localization = ({ children }) => {
    const selectedLanguage = useSelector((state) => state.language);

    // Ensure selectedLanguage is a valid string
    const getValidLanguage = () => {
        // If selectedLanguage is a string and exists in messages, use it
        if (typeof selectedLanguage === 'string' && messages[selectedLanguage]) {
            return selectedLanguage;
        }
        
        // Try localStorage as fallback
        try {
            const stored = localStorage.getItem('language');
            if (stored) {
                const parsed = JSON.parse(stored);
                const lang = typeof parsed === 'string' ? parsed : parsed.language || 'en';
                if (messages[lang]) return lang;
            }
        } catch (error) {
            console.error('Error loading language:', error);
        }
        
        // Default to 'en'
        return 'en';
    };
    
    const currentLanguage = getValidLanguage();

    return (
        <IntlProvider locale={currentLanguage} messages={messages[currentLanguage]}>
            {children}
        </IntlProvider>
    );
};

Localization.propTypes = {
    children: PropTypes.element.isRequired
};

export default Localization;